import NewUserView from '../components/NewUserView';

export default NewUserView;
